import { useAtomValue } from 'jotai';

import { type Surface, useActiveBranding } from '@growtherapy/tailwind/react';

import { userTypeAtom } from '../../auth/state';
import { UserType } from '../../types';

export function useActiveBrand() {
  const userType = useAtomValue(userTypeAtom);
  const surface: Surface = userType === UserType.PROVIDER ? 'provider' : 'client';
  const { activeBrand } = useActiveBranding(surface);

  return activeBrand;
}
